import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const DocFileImage = (t0)=>{
    const $ = c(15);
    const { width, height } = t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M12.9961 13C12.9961 8.58172 16.5778 5 20.9961 5H44.9963C47.2055 5 48.9963 6.79086 48.9963 9V47C48.9963 49.2091 47.2055 51 44.9963 51H20.9961C16.5778 51 12.9961 47.4183 12.9961 43V13Z",
            fill: "#1A47BB"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M21.0039 35.5138C16.5857 35.5139 13.0039 39.0956 13.0039 43.5137V35.5138H21.0039Z",
            fill: "url(#paint0_linear_17004_1869)"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M49.0049 31.5128C49.0049 33.7218 47.2138 35.5125 45.0049 35.5128L13.0039 35.5138V15.1964H49.0039L49.0049 31.5128Z",
            fill: "url(#paint1_linear_17004_1869)"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M21.0039 20.334C16.5856 20.334 13.0039 23.9157 13.0039 28.334V20.334H21.0039Z",
            fill: "url(#paint2_linear_17004_1869)"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M45.0049 5C47.2138 5.00026 49.0049 6.79102 49.0049 9V16.333C49.0049 18.542 47.2138 20.3327 45.0049 20.333L13.0039 20.334V13C13.0039 8.5818 16.5857 5.00013 21.0039 5H45.0049Z",
            fill: "url(#paint3_linear_17004_1869)"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M7 33.0736C7 30.8645 8.79086 29.0736 11 29.0736H21.0001C23.2093 29.0736 25.0001 30.8645 25.0001 33.0736V43.4736C25.0001 45.6828 23.2093 47.4736 21.0001 47.4736H11C8.79086 47.4736 7 45.6828 7 43.4736V33.0736Z",
            fill: "url(#paint4_linear_17004_1869)"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M12.2803 42.9136L9.63746 33.6773H11.7707L13.2995 40.0949H13.3762L15.0629 33.6773H16.8895L18.5717 40.1084H18.6528L20.1817 33.6773H22.3149L19.6721 42.9136H17.7689L16.01 36.8748H15.9379L14.1835 42.9136H12.2803Z",
            fill: "white"
        });
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
        $[6] = t7;
    } else {
        t1 = $[0];
        t2 = $[1];
        t3 = $[2];
        t4 = $[3];
        t5 = $[4];
        t6 = $[5];
        t7 = $[6];
    }
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint0_linear_17004_1869",
            x1: "50.4299",
            y1: "17.588",
            x2: "18.9151",
            y2: "24.2464",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#9A6BFE"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#2370EF"
                })
            ]
        });
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint1_linear_17004_1869",
            x1: "50.4299",
            y1: "17.588",
            x2: "18.9151",
            y2: "24.2464",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#9A6BFE"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#2370EF"
                })
            ]
        });
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint2_linear_17004_1869",
            x1: "53.805",
            y1: "5",
            x2: "16.6115",
            y2: "15.6449",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#958CFF"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#7EE2FF"
                })
            ]
        });
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint3_linear_17004_1869",
            x1: "53.805",
            y1: "5",
            x2: "16.6115",
            y2: "15.6449",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#958CFF"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#7EE2FF"
                })
            ]
        });
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t8,
                t9,
                t10,
                t11,
                /*#__PURE__*/ jsxs("linearGradient", {
                    id: "paint4_linear_17004_1869",
                    x1: "8.95001",
                    y1: "30.9904",
                    x2: "24.4542",
                    y2: "47.1337",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ jsx("stop", {
                            stopColor: "#165AE3"
                        }),
                        /*#__PURE__*/ jsx("stop", {
                            offset: "1",
                            stopColor: "#0C327D"
                        })
                    ]
                })
            ]
        });
        $[11] = t12;
    } else t12 = $[11];
    let t13;
    if ($[12] !== height || $[13] !== width) {
        t13 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 56 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                t12
            ]
        });
        $[12] = height;
        $[13] = width;
        $[14] = t13;
    } else t13 = $[14];
    return t13;
};
export { DocFileImage };
